import { createSelector } from 'reselect';
import type { RootState } from 'typesafe-actions';

import { getDestinationCountry } from 'store/bookingStep/selectors';
import { getDestinationCount } from 'store/reservationList/selectors';

import type { Campaign, Data, Location } from 'Campaign-Types';

import type { CampaignState } from './reducer';
import { RulesEngine } from './RuleEngine';

export const getCampaignsData = (state: RootState) => state.campaign;

export const getAllCampaigns = createSelector(
  getCampaignsData,
  (state: CampaignState) => state.campaignData,
);

export const getCampaignsForLocations = (locations: Location[]) =>
  createSelector(getAllCampaigns, (campaigns: Campaign[]) => {
    const filteredCampaigns = campaigns.filter(campaign => {
      return campaign.locations.some(location => locations.includes(location));
    });
    return filteredCampaigns;
  });

export const getValidCampaignsForLocations = (locations: Location[]) =>
  createSelector(
    getCampaignsForLocations(locations),
    getDestinationCountry,
    getDestinationCount,
    (campaigns: Campaign[], destinationCountry, countryCount) => {
      const ruleEngine = new RulesEngine();
      const data: Data = {
        'reservationList.upcomingReservations.destination.Japan.count': countryCount['Japan'],
        'bookingStep.destination.country': destinationCountry,
      };
      ruleEngine.setData(data);
      const validCampaigns = campaigns.filter(campaign => {
        if (!campaign.conditions) {
          return true;
        } 
          return ruleEngine.evaluate(campaign.conditions);
      });
      return validCampaigns;
    },
  );
